/** @format */

import {CampaignKind} from 'types';

export enum RecommendationType {
  RSA_PLATFORM = 'as-kpi-place',
  GENDER_AGE = 'as-kpi-age-gender',
  REGION = 'as-kpi-geo',
  NOT_FOUND_PAGES = 'as-404',
  AUTO_TARGETING = 'as-autotargeting-high-bid',
}

export interface BaseRecommendationData {
  subAccount?: string | null;
}

export interface RSAPlatformData extends BaseRecommendationData {
  showType?: CampaignKind;
  platform: string;
  plannedKPI: string;
  actualKPI: string;
}

export interface GenderAgeData extends BaseRecommendationData {
  showType: CampaignKind;
  gender: string;
  age: string;
  plannedKPI: string;
  actualKPI: string;
  correction?: string;
}

export interface RegionData extends BaseRecommendationData {
  showType: CampaignKind;
  region: string;
  plannedKPI: string;
  actualKPI: string;
  correction?: string;
}

export interface NotFoundPagesData extends BaseRecommendationData {
  campaignId?: string | null;
  campaignName?: string | null;
  linkType: string;
  link: string;
}

export interface AutoTargetingData extends BaseRecommendationData {
  showType: CampaignKind;
  campaignId?: string | null;
  campaignName?: string | null;
  groupId: string;
  groupName: string;
  autoTargetingRate: string;
}

export type RecommendationData =
  | RSAPlatformData
  | GenderAgeData
  | RegionData
  | NotFoundPagesData
  | AutoTargetingData;

export interface RSAModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  type: RecommendationType | string;
  isMediaCampaign?: boolean;
}
